import { forwardRef } from "react";
import clsx from "clsx";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
  submit?: boolean;
  loading?: boolean;
  noninteractive?: boolean;
  icon?: boolean;
  variant?:
    | "solid"
    | "solid-gradient"
    | "surface"
    | "solid-surface"
    | "solid-outline"
    | "solid-outline-gradient"
    | "solid-surface-gradient"
    | "soft"
    | "link"
    | "ghost";
  color?: "accent" | "gray" | "matched" | "white" | "inverted" | "green";
  size?: "md";
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      className = "",
      noninteractive = false,
      variant = "solid-gradient",
      color = "accent",
      submit = false,
      loading = false,
      icon,
      size = "md",
      ...props
    },
    forwardedRef,
  ) => {
    return (
      <button
        type={submit ? "submit" : "button"}
        className={clsx(
          "btn outline-0",
          {
            "variant-solid": variant === "solid",
            "variant-solid-gradient": variant === "solid-gradient",
            "variant-surface": variant === "surface",
            "variant-solid-surface": variant === "solid-surface",
            "variant-solid-outline": variant === "solid-outline",
            "variant-solid-outline-gradient": variant === "solid-outline-gradient",
            "variant-solid-surface-gradient": variant === "solid-surface-gradient",
            "variant-soft": variant === "soft",
            "variant-ghost": variant === "ghost",
            "variant-link": variant === "link",

            "variant-accent": color === "accent",
            "variant-gray": color === "gray",
            "variant-matched": color === "matched",
            "variant-white": color === "white",
            "variant-inverted": color === "inverted",

            "btn-icon": icon,

            "btn-size-md": size === "md",

            "mz-loading": loading,

            "mz-noninteractive cursor-auto": noninteractive,
          },
          className,
        )}
        ref={forwardedRef}
        aria-busy={loading}
        {...props}
      >
        {children}
        <div className="mz-loader ml-[1em]" />
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
